import React, { useEffect, createElement } from 'react';
import { SEO } from '../components/seo/SEO';
import { BreadcrumbSchema } from '../components/seo/Schema';
import { InteractivePipeline } from '../components/sections/InteractivePipeline';
import { SimpleEngineOverview } from '../components/sections/SimpleEngineOverview';
import { ClientLogos } from '../components/sections/ClientLogos';
export function HowItWorks() {
  useEffect(() => {
    // Load Wistia player script
    const script = document.createElement('script');
    script.src = 'https://fast.wistia.com/player.js';
    script.async = true;
    document.head.appendChild(script);
    // Load Wistia embed script
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/yfxrcvgduq.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    return () => {
      // Cleanup scripts on unmount
      if (script.parentNode) document.head.removeChild(script);
      if (embedScript.parentNode) document.head.removeChild(embedScript);
    };
  }, []);
  return <>
      <SEO title="How The HIRE Advantage Works | D2D Recruiting System" description="See how the HIRE Advantage combines recruiting, onboarding, and retention frameworks to help door-to-door and direct sales companies scale predictably." canonical="/how-it-works" ogTitle="How Our D2D Recruiting System Works" ogDescription="Discover the proven system that helps door-to-door companies recruit, retain, and scale high-performing sales teams." ogImage="https://uploadthingy.s3.us-west-1.amazonaws.com/vZQb1BRCvwHNhKSytwSdua/Screenshot_2025-11-25_at_12.06.50_AM.png?v=2" keywords="sales recruiting system, door to door sales hiring, recruit door to door sales reps, sales team scaling system" data-id="element-1312" />

      <BreadcrumbSchema items={[{
      name: 'Home',
      url: '/'
    }, {
      name: 'How It Works',
      url: '/how-it-works'
    }]} data-id="element-1313" />

      <div className="pt-20" data-id="element-1314">
        {/* Hero */}
        <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-gradient-to-br from-gray-50 to-white" data-id="element-1315">
          <div className="container-custom" data-id="element-1316">
            <div className="max-w-4xl mx-auto text-center" data-id="element-1317">
              <div className="inline-block bg-amber-light text-amber-dark px-4 py-2 rounded text-sm font-semibold mb-6" data-id="element-1318">
                The HIRE Advantage
              </div>
              <h1 className="mb-6" data-id="element-1319">How It Works</h1>
              <p className="text-body-large leading-relaxed mb-8" data-id="element-1320">
                This is a consistent, systematic approach to recruiting that
                takes out the guesswork. It delivers predictable results and
                positive ROI, eliminates leadership burnout, and helps you
                capture the top talent that is currently going to your
                competitors.
              </p>
            </div>
          </div>
        </section>

        {/* Wistia Video */}
        <section className="py-12 md:py-16 bg-white" data-id="element-1321">
          <div className="container-custom" data-id="element-1322">
            <div className="max-w-4xl mx-auto" data-id="element-1323">
              <div className="bg-navy rounded-2xl p-6 md:p-8 shadow-2xl" data-id="element-1324">
                <div className="aspect-video bg-navy-light rounded-lg overflow-hidden border-2 border-amber/20" data-id="element-1325">
                  <style data-id="element-1326">{`
                    wistia-player[media-id='yfxrcvgduq']:not(:defined) { 
                      background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/yfxrcvgduq/swatch'); 
                      display: block; 
                      filter: blur(5px); 
                      padding-top: 56.25%; 
                    }
                  `}</style>
                  <wistia-player media-id="yfxrcvgduq" aspect="1.7777777777777777" className="w-full h-full" data-id="element-1327"></wistia-player>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Interactive Pipeline */}
        <InteractivePipeline data-id="element-1328" />

        {/* Simple Engine Overview */}
        <SimpleEngineOverview data-id="element-1329" />

        {/* Client Logos */}
        <ClientLogos data-id="element-1330" />

        {/* Final CTA */}
        <section className="section-padding bg-white" data-id="element-1331">
          <div className="container-custom" data-id="element-1332">
            <div className="max-w-3xl mx-auto text-center" data-id="element-1333">
              <h2 className="mb-6" data-id="element-1334">Ready to See the System?</h2>
              <p className="text-body-large mb-8 leading-relaxed" data-id="element-1335">
                Every system is custom-built for your market and your goals.
                Let's map yours out.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1336">
                <a href="/book-call" className="inline-block bg-amber hover:bg-amber-dark text-navy font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-1337">
                  Schedule Your Strategy Call →
                </a>
                <a href="/case-studies" className="inline-block border-2 border-navy text-navy hover:bg-navy hover:text-white font-bold px-8 py-4 rounded-lg transition-colors" data-id="element-1338">
                  View Case Studies
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>;
}